// ---------- initialize and render the React application in the browser ------------
// ----------------------------------------------------------------------------------
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // import the styles for the application
import App from './App'; // import the main application content

// get the root element from the HTML and render the React application into it
const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render( 
  <React.StrictMode>
    <App /> 
  </React.StrictMode>
);
